import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

export const getAdminToken = () => localStorage.getItem("vv_admin_token") || "";
export const setAdminToken = (t) => localStorage.setItem("vv_admin_token", t);
export const clearAdminToken = () => localStorage.removeItem("vv_admin_token");

export const adminHeaders = () => ({
  headers: { "X-Admin-Token": getAdminToken() },
});
